import { generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

type Props = {
	hotelID: string;
	planID: string;
};

export const HeaderInner = ({ hotelID, planID }: Props) => {
	return (
		<div className="max-w-screen-screen">
			<div className="text-sm">
				<p>
					この画面では送信のオン/オフ、メッセージの上書き設定の変更はできません
					<br />
					変更する場合は、
					<a
						className="gap-x-2 break-all text-link-400"
						href={generatePath(PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.DAYTRIP.DEFAULT, { hotelID, planID })}
					>
						日本語設定ページのメール設定
					</a>
					から変更してください
				</p>
				<p>
					メッセージの編集ができない場合は、
					<a
						className="gap-x-2 break-all text-link-400"
						href={generatePath(PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.DAYTRIP.DEFAULT, { hotelID, planID })}
					>
						日本語設定ページのメール設定
					</a>
					で該当項目の上書き設定を、「このプランの独自に設定」に変更してください
				</p>
			</div>
		</div>
	);
};
